export default __webpack_public_path__ + "static/media/astronaut.437f7abb.png";